import angular from 'angular';
import _ from 'lodash';

var app = angular.module('underwraps');

app.config([
  '$stateProvider',
  '$locationProvider',
  function ($stateProvider, $locationProvider) {
    var resolve = {
      currentUser: [
        'CurrentUserService',
        function (CurrentUserService) {
          return CurrentUserService.checkAuth();
        },
      ],
    };

    $stateProvider.state({
      name: 'home',
      url: '/',
      templateUrl: 'app/pages/home/home.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'login',
      url: '/login',
      templateUrl: 'app/pages/home/home.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'change-password',
      url: '/change-password',
      templateUrl: 'app/pages/change-password/change-password.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'me',
      url: '/me',
      templateUrl: 'app/pages/me/me.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'christmas-list',
      url: '/christmas-list',
      templateUrl: 'app/pages/bedford-list/bedford-list.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'christmas-list-2023',
      url: '/christmas-list-2023',
      templateUrl: 'app/pages/bedford-list-2023/bedford-list.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'christmas-list-2022',
      url: '/christmas-list-2022',
      templateUrl: 'app/pages/bedford-list-2022/bedford-list.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'peeps',
      url: '/peeps',
      templateUrl: 'app/pages/peeps/peeps.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'settings',
      url: '/settings',
      templateUrl: 'app/pages/settings/settings.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'gift-deets',
      url: '/gift-deets/:giftId',
      isNewIdea: false,
      templateUrl: 'app/pages/gift-deets/gift-deets.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'new-idea',
      url: '/new-idea',
      isNewIdea: true,
      templateUrl: 'app/pages/gift-deets/gift-deets.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'new-idea-for-person',
      url: '/new-idea/:friendId',
      isNewIdea: true,
      templateUrl: 'app/pages/gift-deets/gift-deets.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'gift-list',
      url: '/gift-list/:friendId',
      templateUrl: 'app/pages/gift-list/gift-list.tpl.html',
      resolve: resolve,
    });

    $stateProvider.state({
      name: 'gift-deets-for-friend',
      url: '/gift-deets/:friendId',
      templateUrl: 'app/pages/gift-deets/gift-deets.tpl.html',
      resolve: resolve,
    });

    $locationProvider.html5Mode(true);
  },
]);

app.run([
  '$rootScope',
  'CurrentUserService',
  'LoginService',
  '$location',
  '$state',
  '$timeout',
  function ($rootScope, CurrentUserService, LoginService, $location, $state, $timeout) {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      CurrentUserService.checkAuth().then(function () {
        if (!_.includes(['home', 'login', 'change-password'], toState.name) && !CurrentUserService.isLoggedIn) {
          var toPath = $state.href(toState.name, toParams);
          event.preventDefault();
          $state.go('login');
          LoginService.showLogin(toPath);
        }
      });
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      //document.body.scrollTop = document.documentElement.scrollTop = 0;
      $timeout(function () {
        window.scrollTo(0, 0);
      }, 0);
    });
  },
]);
